export const stringWithOutExtraSpaces = (str: string) => str.replace(/\s+/g, ' ').trim();